module.exports = __webpack_public_path__ + "media/images/covid/icons/vent-a5ddd3a5c5f54cabbf530e9fd70bb5a0.png";